import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { Group } from '@/views/dashboard/_type/group'

export interface GroupStrategyRes {
  /** 终端分组策略 */
  group: Group
}

@Injectable()
export class PolicyDeployService {
  constructor (private http: Http) {
  }

  @InvokeThrottle()
  getGroupStrategy () {
    return this.http.post<GroupStrategyRes>('/terminal-group/group-strategy', {})
  }

  @InvokeThrottle()
  deployStrategy (data: { group_id: number, strategy_id: string }) {
    return this.http.post<void>('/group-strategy/deploy', data)
  }
}
